export { default } from "./ScaleDecoratorContainer";
